import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('svh-comms-thread-exp-fe', {
  library: 'svh-comms-thread-exp-fe'
});